import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { MessageStatus } from 'common/dropdownOptions';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function FileStatusFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();

  return (
    <div className="filter-wraper">
      <Dropdown
        options={MessageStatus}
        value={fileManagerFilters?.fileStatus}
        placeholder="By File Status"
        className="file-manager-select col-sm-12"
        onChange={(e) => {
          onFilterChange(e);
          setSelectedRows([]);
        }}
        name="fileStatus"
      />
    </div>
  );
}

export default FileStatusFilter;
